// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae0f460f","239":"a18c95c1","453":"640fd034","732":"d4a5b616"}[chunkId] + ".chunk.js";
};